"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "defaultPortalId", {
  enumerable: true,
  get: function get() {
    return _constants.defaultPortalId;
  }
});
Object.defineProperty(exports, "shallowEqual", {
  enumerable: true,
  get: function get() {
    return _shallowEqual.shallowEqual;
  }
});
Object.defineProperty(exports, "shallowEqualForeignProps", {
  enumerable: true,
  get: function get() {
    return _shallowEqual.shallowEqualForeignProps;
  }
});
var _shallowEqual = require("./shallowEqual");
var _constants = require("./constants");